import React from 'react';
import { Hospital } from '../../hooks/useUsingDashboardHospitals';

type Props = {
  availableHospitals: Hospital[];
  selectedHospitals: string[];
  isLoading: boolean;
  onHospitalChange: (hospitalName: string) => void;
  onSelectAll: () => void;
  onClear: () => void;
};

export const HospitalSelector = ({ 
  availableHospitals, 
  selectedHospitals, 
  isLoading, 
  onHospitalChange, 
  onSelectAll, 
  onClear 
}: Props) => {
  // 全て選択されているかどうかを判定
  const isAllSelected = selectedHospitals.length === availableHospitals.length && availableHospitals.length > 0;
  
  // ボタンのクリック処理
  const handleToggleAll = () => {
    if (isAllSelected) {
      onClear();
    } else {
      onSelectAll();
    }
  };

  return (
    <div className="flex flex-col gap-[16px]">
      <div className="flex flex-col gap-[8px]">
        <label className="text-[14px] text-primary noto-sans-jp-medium">
          表示先選択
        </label>
        <div className="flex gap-[16px]">
          <button
            className="px-[8px] py-[4px] border border-gray-300 rounded-[6px] text-[11px] text-textPrimary noto-sans-jp-regular hover:bg-gray-100"
            onClick={handleToggleAll}
          >
            {isAllSelected ? 'クリア' : '全て選択'}
          </button>
        </div>
        <div className="relative">
          <div 
            className="flex flex-col gap-[8px] max-h-[200px] overflow-y-scroll border border-gray-200 rounded-[8px] p-[12px] bg-gray-50 shadow-inner hospital-list-scroll"
            style={{ 
              scrollbarWidth: 'thin', 
              scrollbarColor: '#9CA3AF #E5E7EB'
            }}
          >
            {isLoading ? (
              <div className="text-[14px] text-textSecondary noto-sans-jp-regular">
                病院リストを読み込み中...
              </div>
            ) : availableHospitals.length > 0 ? (
              availableHospitals.map((hospital) => (
                <label key={hospital.id} className="flex items-center gap-[8px] cursor-pointer hover:bg-gray-100 p-[4px] rounded-[4px] transition-colors">
                  <input
                    type="checkbox"
                    checked={selectedHospitals.includes(hospital.name)}
                    onChange={() => onHospitalChange(hospital.name)}
                    className="w-[16px] h-[16px]"
                  />
                  <span className="text-[14px] text-textPrimary noto-sans-jp-regular">
                    {hospital.name}
                  </span>
                </label>
              ))
            ) : (
              <div className="text-[14px] text-textSecondary noto-sans-jp-regular">
                病院がありません
              </div>
            )}
          </div>
          {/* スクロール可能であることを示すグラデーション */}
          {availableHospitals.length > 5 && (
            <div className="absolute bottom-0 left-0 right-0 h-[12px] bg-gradient-to-t from-gray-50 to-transparent pointer-events-none rounded-b-[8px]"></div>
          )}
        </div>
      </div>
    </div>
  );
}; 